import React from "react";
import ReactDOM from "react-dom/client";
import "index.css";
import App from "app/App";
import reportWebVitals from "reportWebVitals";
import { ThemeContextProvider } from "shared/contexts/ThemeContext";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "shared/contexts/AuthProvider";
import { UserOrgProvider } from "shared/contexts/UserOrgContext";
import { UserNotificationProvider } from "shared/contexts/UserNotificationProvider";
import PerformanceMonitor from "shared/components/ui/PerformanceMonitor";
import { HelmetProvider } from "react-helmet-async";
import { PageTitleProvider } from "shared/contexts/PageTitleContext";
import "./i18n"; // Import i18n configuration

import("bootstrap/dist/css/bootstrap.min.css");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeContextProvider>
        <BrowserRouter>
          <UserNotificationProvider>
            <AuthProvider>
              <UserOrgProvider>
                <PageTitleProvider>
                  <App />
                </PageTitleProvider>
                {process.env.NODE_ENV === "development" && (
                  <PerformanceMonitor enabled={true} />
                )}
              </UserOrgProvider>
            </AuthProvider>
          </UserNotificationProvider>
        </BrowserRouter>
      </ThemeContextProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
